import React from 'react'
import { Link, withRouter } from 'react-router-dom'

import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { AgGridReact } from 'ag-grid-react'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import { Button } from 'primereact/button'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import { Toolbar } from 'primereact/toolbar'

import { api, request } from '../../util/handlerRequestUtil'
class ListMember extends React.Component {
  constructor(props) {
    super(props)
    this.gridApi = {}
    this.state = {
      columnDefs: [
        { headerName: 'Nome', field: 'name', width: 30, filter: 'agTextColumnFilter' },
        { headerName: 'Email', field: 'emailAddress', width: 30, filter: 'agTextColumnFilter' },
        { headerName: 'Time', field: 'organization_names', width: 30, filter: 'agTextColumnFilter' },
        { headerName: 'Regional', field: 'region_names', width: 30, filter: 'agTextColumnFilter' },
        { headerName: 'Distrito', field: 'district_names', width: 30, filter: 'agTextColumnFilter' },
        { headerName: 'Perfil', field: 'profile_name', width: 30, filter: 'agTextColumnFilter' },
        {
          headerName: 'Status do Usuário',
          field: 'active',
          width: 30,
          filter: 'agTextColumnFilter',
          valueFormatter: (params) => (params.value ? 'Ativo' : 'Inativo')
        },
        {
          headerName: 'editar',
          field: 'id',
          width: 9,
          sortable: false,
          resizable: false,
          cellRenderer: this.actionCellRenderer,
          cellStyle: {
            height: '100%',
            display: 'flex ',
            'justify-content': 'center',
            'align-items': 'center '
          }
        }
      ],
      defaultColDef: {
        sortable: true,
        resizable: true,
        minWidth: 1,
        width: 100,
        enableRowGroup: false,
        enablePivot: false,
        enableValue: true,
        floatingFilter: true
      },
      // sideBar: {
      //   toolPanels: ['columns'],
      // },
      // rowGroupPanelShow: 'always',
      // pivotPanelShow: 'always',
      rowData: null
    }
  }

  goToCreateMember() {
    const { history } = this.props

    history.push('/member/create')
  }

  async listMembers(params) {
    try {
      const data = await request(api.listMembers({ ...params }))
      return data
    } catch (error) {
      console.error('Error getting members:', error)
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit()

    this.listMembers().then((data) => {
      const formattedData = data.map(({ districts, regions, organizations, user, ...rest }) => ({
        ...rest,
        organization_names: (organizations || []).map(({ name }) => name).join(', '),
        region_names: (regions || []).map(({ name }) => name).join(', '),
        district_names: (districts || []).map(({ name }) => name).join(', '),
        profile_name: user?.profile?.name || ''
      }))

      params.api.setRowData(formattedData)
    })
  }

  renderHeader() {
    const leftContents = (
      <React.Fragment>
        <h2>
          <b>Profissionais</b>
        </h2>
      </React.Fragment>
    )

    const rightContents = (
      <React.Fragment>
        <div style={{ display: 'flex', marginRight: 8 }}>
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search"> </InputIcon>
            <InputText
              style={{ width: '100%' }}
              value={this.state.value3}
              onChange={(e) => this.gridApi.setQuickFilter(e.target.value)}
              placeholder="Pesquisar"
            />
          </IconField>
        </div>
        <Button icon="pi pi-file-excel" className="p-button-success mr-2" onClick={() => this.onBtnExport()} />
        <Button icon="pi pi-plus" className="p-button-sm" onClick={() => this.goToCreateMember()} />
      </React.Fragment>
    )

    return <Toolbar start={leftContents} end={rightContents} />
  }

  render() {
    return (
      <>
        {this.renderHeader()}
        <div style={{ width: '100%', height: '70vh' }}>
          <div
            style={{
              height: '100%',
              width: '100%'
            }}
            className="ag-theme-alpine"
          >
            <AgGridReact
              columnDefs={this.state.columnDefs}
              defaultColDef={this.state.defaultColDef}
              onGridReady={this.onGridReady}
              rowData={this.state.rowData}
              rowSelection={'single'}
              getRowStyle={(params) => ({ color: params.data.active ? 'inherit' : 'gray' })}
            />
          </div>
        </div>
      </>
    )
  }

  onBtnExport = () => {
    this.gridApi.exportDataAsCsv()
  }

  actionCellRenderer(params) {
    return (
      <Link to={`/member/${params.value}`}>
        <Button icon="pi pi-file-edit" className="btn btn-info" style={{ height: 30, width: 30, lineHeight: 0.5 }} />
      </Link>
    )
  }
}

export default withRouter(ListMember)
